import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { CurrentLoginPage } from "node-library/dist/constants";
import { useNavigate } from "react-router-dom";

import { SemanticColor } from "node-library/dist/colors";

import { BlueButton } from "../../common-components/button";

interface Props {
	setCurrentPage: React.Dispatch<React.SetStateAction<CurrentLoginPage>>;
}

export default function ForgetPasswordSuccessPage(props: Props) {
	const { t: translation } = useTranslation();

	const navigate = useNavigate();

	return (
		<div className="login-container">
			<div className="typography-heading-01 login-heading-01 ">
				<div>{translation("PasswordResetEmailSent")}</div>
			</div>
			<div className="mail-icon"></div>
			<div className="typography-body-02 register-success-paragraphs">
				<div>{`${translation("PasswordResetEmailSentDescriptionOne")} `}</div>
				<div>
					<span>{`${translation(
						"PasswordResetEmailSentDescriptionTwo"
					)} `}</span>
					<span
						style={{ cursor: "pointer", color: SemanticColor.INFO_MEDIUM }}
						onClick={() => {
							props.setCurrentPage(CurrentLoginPage.FORGET_PASSWORD);
						}}
					>
						<u>{translation("ResendEmail")}</u>
					</span>
				</div>
			</div>

			<BlueButton
				id="login-button"
				children={translation("SignInNow")}
				size={"flex"}
				onClick={() => {
					props.setCurrentPage(CurrentLoginPage.LOGIN);
				}}
			></BlueButton>
		</div>
	);
}
